module.exports = __webpack_public_path__ + "img/cooperative-growth.7fcd269c.svg";